<app-lms-modal-frame [title]="'Branch Report'" [pageHeadWidth]="600">
  <div modal-body class="p-0">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <table class="loans-table" #TABLE>
            <caption>
              {{ areaName ? 'Area: ' + areaName : 'All Areas' }}
              <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
            </caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Branch</th>
                <th scope="col">Branch Serial</th>
                <th scope="col">Created On</th>
                <th scope="col">Completed On</th>
                <th scope="col">Duration</th>
                <th scope="col">Loan Status</th>
                <th scope="col">First Name/s</th>
                <th scope="col">Surname</th>
                <th scope="col">Cell Number</th>
                <th scope="col">ID Number</th>
                <th scope="col">Client Status</th>
                <th scope="col">Client Number</th>
                <th scope="col">First Debit Date</th>
                <th scope="col" class="amount">Capital (R)</th>
                <th scope="col">Term</th>
                <th scope="col" class="amount">Nett Income</th>
                <th scope="col" class="amount">Living Exp</th>
                <th scope="col" class="amount">Max Affordability</th>
                <th scope="col" class="amount">Max Installment</th>
                <th scope="col" class="amount">NCR Limit</th>
                <th scope="col">My Benefits</th>
                <th scope="col" class="amount">Initiation Fee</th>
                <th scope="col" class="amount">Interest Rate</th>
                <th scope="col" class="amount">Total Repayment</th>
                <th scope="col" class="amount">Total Interest & Fees</th>
                <th scope="col" class="amount">Installment</th>
                <th scope="col">Pay Date</th>
                <th scope="col">Product</th>
                <th scope="col">Collect Bank</th>
                <th scope="col">Collect Acc No</th>
                <th scope="col">Collect Branch Code</th>
                <th scope="col">Collect Acc Type</th>
                <th scope="col">Disburse Bank</th>
                <th scope="col">Disburse Acc No</th>
                <th scope="col">Disburse Branch Code</th>
                <th scope="col">Disburse Acc Type</th>
                <th scope="col">Payout Method</th>
                <th scope="col">Loan Reference</th>
                <th scope="col">Mandate Reference</th>
                <th scope="col">Reject Reason</th>
                <th scope="col">OPT Override</th>
                <th scope="col">Created By</th>
                <th scope="col">Employer TNR</th>
                <th scope="col">Employer Name</th>
                <th scope="col">Area</th>
                <th scope="col">Compuscore</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of branchReportList | paginate: config">
                <td>{{ row.id }}</td>
                <td>{{ row.branchName }}</td>
                <td>{{ row.branchSerial }}</td>
                <td>{{ row.createdOn | date: 'yyyy-MM-dd HH:mm' }}</td>
                <td>{{ row.completedOn | date: 'yyyy-MM-dd HH:mm' }}</td>
                <td>{{ row.applicationDuration }}</td>
                <td>{{ row.loanStatus }}</td>
                <td>{{ row.firstName }}</td>
                <td>{{ row.lastName }}</td>
                <td>{{ row.cellNumber }}</td>
                <td>{{ row.idNumber }}</td>
                <td>{{ row.clientStatus }}</td>
                <td>{{ row.clientNumber }}</td>
                <td>{{ row.firstDebitDate | date: 'yyyy-MM-dd' }}</td>
                <td class="amount">{{ row.capital | number: '1.2-2' }}</td>
                <td>{{ row.term }}</td>
                <td class="amount">{{ row.nettIncome | number: '1.2-2' }}</td>
                <td class="amount">{{ row.livingExp | number: '1.2-2' }}</td>
                <td class="amount">{{ row.maxAffordability | number: '1.2-2' }}</td>
                <td class="amount">{{ row.maxInstallment | number: '1.2-2' }}</td>
                <td class="amount">{{ row.ncrLimit | number: '1.2-2' }}</td>
                <td>{{ row.myBenefits }}</td>
                <td class="amount">{{ row.initiationFee | number: '1.2-2' }}</td>
                <td class="amount">{{ row.interestRate | number: '1.2-2' }}</td>
                <td class="amount">{{ row.totalRepayable | number: '1.2-2' }}</td>
                <td class="amount">{{ row.totalInterestAndFees | number: '1.2-2' }}</td>
                <td class="amount">{{ row.installment | number: '1.2-2' }}</td>
                <td>{{ row.payDate }}</td>
                <td>{{ row.productName }}</td>
                <td>{{ row.collectBank }}</td>
                <td>{{ row.collectAccountNumber }}</td>
                <td>{{ row.collectBranchCode }}</td>
                <td>{{ row.collectAccountType }}</td>
                <td>{{ row.disburseBank }}</td>
                <td>{{ row.disburseAccountNumber }}</td>
                <td>{{ row.disburseBranchCode }}</td>
                <td>{{ row.disburseAccountType }}</td>
                <td>{{ row.payoutMethod }}</td>
                <td>{{ row.loanReference }}</td>
                <td>{{ row.mandateReference }}</td>
                <td>{{ row.rejectReason }}</td>
                <td>{{ row.optOverride }}</td>
                <td>{{ row.createdBy }}</td>
                <td>{{ row.employerTnr }}</td>
                <td>{{ row.employerName }}</td>
                <td>{{ row.areaName }}</td>
                <td>{{ row.compuscore }}</td>
              </tr>
              <tr *ngIf="branchReportList.length === 0">
                <td colspan="47" class="text-center text-muted py-3">No data available.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="paginator-row">
          <pagination-controls [id]="config.id || 'area-report-pager'"
            (pageChange)="config.currentPage = $event"></pagination-controls>
        </div>
      </div>

    </section>
  </div>

  <div modal-actions class="action-bar">
    <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
      <i class="fas fa-file-excel fa-fw"></i> Export to Excel
    </button>
    <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
  </div>
</app-lms-modal-frame>
